import { h, toast } from '../dom';
import { apiUrl, remoteConfig, setApiUrl } from '../../config';
import { isLoggedIn, logout } from '../../auth/oidc';

/**
 * Which Booth server the app talks to. Only changeable here, on purpose: links can
 * never silently point the app at another server (phishing protection).
 */
export function renderSettings(root: HTMLElement) {
  const input = h('input.field', { value: apiUrl(), placeholder: 'https://booth.ten-mien-cua-ban.vn', inputMode: 'url' });
  const info = h('div.kv');
  const show = async () => {
    info.replaceChildren(h('p.tiny', {}, 'Đang kiểm tra…'));
    const c = await remoteConfig();
    info.replaceChildren(c
      ? h('div', {}, h('p', {}, '✅ Kết nối được'), h('p.tiny', {}, `Đăng nhập: ${c.issuer}`),
        h('p.tiny', {}, `TURN: ${c.turn ? 'có' : 'không'} · Relay: ${c.relays.length || 'mặc định'}`))
      : h('p', {}, '❌ Không kết nối được máy chủ này'));
  };
  const save = async () => {
    const changed = input.value.trim().replace(/\/$/, '') !== apiUrl();
    try {
      setApiUrl(input.value || null);
    } catch (e) {
      return toast((e as Error).message, 4000);
    }
    if (changed && isLoggedIn()) {
      await logout(); // tokens of one server must never be sent to another
      toast('Đã đổi máy chủ – hãy đăng nhập lại');
    }
    void show();
  };
  root.replaceChildren(h('main.libpage', {},
    h('header.bar', {}, h('a.icon', { href: isLoggedIn() ? '#/me' : '#/login', title: 'Quay lại' }, '←'), h('h2', {}, 'Cài đặt máy chủ')),
    h('section.card', {},
      h('label.tiny', {}, 'Địa chỉ máy chủ Booth (để trống = mặc định của bản cài)'),
      input,
      h('div.row', {}, h('button.primary', { onclick: () => void save() }, 'Lưu & kiểm tra')),
      info,
      h('p.tiny', {}, 'Chỉ nhập địa chỉ máy chủ bạn tin cậy. Đổi máy chủ sẽ đăng xuất tài khoản hiện tại.')),
  ));
  void show();
}
